import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

// B25 (plan 2026-10-27 §D2): saved order lists and the quick-order matcher.
// The business is the caller's current business; another business's list is a 404.

export interface ISavedListRow {
  id: string
  name: string
  supplierBusinessId: string
  lineCount: number
  updatedAt: string
}

export interface ISavedListLine {
  variantId: string
  parentVariantId?: string | null
  quantity: number
}

export interface ISavedList {
  id: string
  name: string
  supplierBusinessId: string
  lines: ISavedListLine[]
}

export type MatchStatus = "MATCHED" | "LOW_STOCK" | "NOT_FOUND"

export interface IMatchRow {
  row: number
  code: string
  quantity: number
  status: MatchStatus
  variantId?: string
  parentVariantId?: string
  name?: string
  skuCode?: string
  image?: string
  price?: number
  available?: number
  /** LOW_STOCK only: the quantity that can be added (= available). */
  addQuantity?: number
}

export const list = async (supplierBusinessId: string): Promise<{ rows: ISavedListRow[] }> => {
  return httpRequest.get("/ord/saved-list", { supplierBusinessId })
}

export const get = async (id: string): Promise<ISavedList> => {
  return httpRequest.get(`/ord/saved-list/${id}`)
}

export const create = async (data: {
  name: string
  supplierBusinessId: string
  lines: ISavedListLine[]
}): Promise<{ id: string }> => {
  return httpRequest.post("/ord/saved-list", data as never)
}

export const update = async (id: string, data: { name?: string; lines?: ISavedListLine[] }): Promise<unknown> => {
  return httpRequest.put(`/ord/saved-list/${id}`, data as never)
}

export const remove = async (id: string): Promise<unknown> => {
  return httpRequest.del(`/ord/saved-list/${id}`)
}

/** Matches typed / scanned codes against the supplier's variants (skuCode or barCode, case-insensitive). */
export const match = async (data: {
  supplierBusinessId: string
  rows: { code: string; quantity?: number }[]
}): Promise<IMatchRow[]> => {
  const res: unknown = await httpRequest.post("/ord/quick-order/match", data as never)
  if (Array.isArray(res)) return res as IMatchRow[]
  const rows = (res as { rows?: IMatchRow[] } | null)?.rows
  return Array.isArray(rows) ? rows : []
}
